module.exports = __webpack_public_path__ + "static/media/id-ID.9561f624.md";